import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, TextField, Typography, Paper, FormGroup, FormLabel, FormControl, Select, MenuItem, InputLabel } from '@material-ui/core';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetDefaultAgendasDetails, GetMondays, GetValidTimetables, SearchTimetable, SetFixedDatetimeFormat, ExcludeSpecialCharactersFromInputTypeNumber } from '../../../../services/helpers.js';
import { Dialog, AppBar, Toolbar, Checkbox, FormControlLabel, Slide } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from '@material-ui/core/IconButton';
import { Redirect } from 'react-router-dom';
import FileCopy from '@material-ui/icons/FileCopy';
import Delete from '@material-ui/icons/Delete';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { WorkshopAgendasUrl, WorkshopAgendasWithIdUrl, WorkshopTimetablesUrl } from '../../../../constants/apiUrls.js';
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Memoized month accordion to prevent unnecessary re-renders
class MonthAccordion extends Component {
    constructor(props) {
        super(props);
        // Cache mondays calculation per month/year combination
        this._mondaysCache = null;
        this._cachedMonth = null;
        this._cachedYear = null;
    }

    shouldComponentUpdate(nextProps) {
        return (
            nextProps.expanded !== this.props.expanded ||
            nextProps.year !== this.props.year ||
            nextProps.agendaDetails !== this.props.agendaDetails ||
            nextProps.timetables !== this.props.timetables
        );
    }

    getMondaysOfMonth() {
        const { month, year } = this.props;
        
        // Return cached value if month/year hasn't changed
        if (this._mondaysCache && this._cachedMonth === month && this._cachedYear === year) {
            return this._mondaysCache;
        }
        
        // Calculate and cache
        this._mondaysCache = GetMondays(month, year);
        this._cachedMonth = month;
        this._cachedYear = year;
        
        return this._mondaysCache;
    }

    render() {
        const {
            month,
            monthName,
            year,
            resources,
            expanded,
            agendaDetails,
            timetables,
            onExpandChange,
            onTimetableChange,
            onTimetableReset,
            onTimetablesCopy
        } = this.props;

        const monthFix = month < 9 ? "0" + (month + 1) : (month + 1);
        const mondaysOfMonth = this.getMondaysOfMonth();

        return (
            <Accordion
                id={`month${month}`}
                name={`month${month}`}
                expanded={expanded}
                onChange={onExpandChange}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`month${monthFix}-content`}>
                    <Typography style={{ textAlign: "left" }}>{monthName}</Typography>
                    <Typography>
                        {resources["FirstMondayOf"]} {monthName} {resources["is"]} {mondaysOfMonth[0].getDate()}
                    </Typography>
                </AccordionSummary>
                {/* Only render content when expanded - key performance optimization */}
                {expanded && (
                    <AccordionDetails>
                        <Typography>
                            {mondaysOfMonth.map(monday => {
                                const fixedDatetime = SetFixedDatetimeFormat(monday);
                                const dayNumber = monday.getDate();
                                const labelMonth = `${dayNumber}.${monthFix}.${year}`;
                                const isFirstWeek = fixedDatetime === agendaDetails[0].startOfWeek;

                                return (
                                    <div className='col-md-12' style={{ display: "flex", justifyContent: "space-between" }} key={labelMonth}>
                                        <div className="col-md-10" style={{ padding: 0 }}>
                                            <EnhancedDropdownComponent
                                                resources={resources}
                                                value={SearchTimetable(monday, agendaDetails)}
                                                options={timetables}
                                                placeholder={resources["DefaultDropdownValue"]}
                                                labelText={labelMonth}
                                                id={`select-${labelMonth}`}
                                                inputName={fixedDatetime}
                                                handleChange={onTimetableChange}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <Delete
                                                name={fixedDatetime}
                                                className=""
                                                style={{ color: "#53B3EA", margin: "5px", cursor: "pointer" }}
                                                onClick={() => onTimetableReset(fixedDatetime)}
                                            />
                                            {isFirstWeek ? (
                                                <FileCopy
                                                    className=""
                                                    style={{ color: "#53B3EA", margin: "5px", cursor: "pointer" }}
                                                    onClick={onTimetablesCopy}
                                                />
                                            ) : (
                                                <div></div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </Typography>
                    </AccordionDetails>
                )}
            </Accordion>
        );
    }
}

export default class AgendaNew extends Component {
    constructor(props) {
        super(props);
        var agendaId = undefined;

        if (this.props !== undefined) {
            agendaId = this.props.agendaId;
        }

        const currentYear = (new Date()).getFullYear();

        this.state = {
            id: 0,
            description: "",
            year: currentYear,
            isActive: false,
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            loading: false,
            editedAgendaId: agendaId,
            requestInProgress: false,
            openEditPopup: true,
            showEditAgenda: false,
            redirect: null,
            agendasWasCreated: false,
            timetables: [],
            agendaDetails: GetDefaultAgendasDetails(currentYear),
            monthExpended: ""
        };

        // Cache month names to avoid recreation on every render
        this._monthsCache = null;
        this._cachedYear = null;
    }

    componentDidMount() {
        // Load timetables and agenda in parallel for faster initial load
        const promises = [this.getTimetables()];
        
        if (this.state.editedAgendaId !== undefined) {
            promises.push(this.getAgendaById(this.state.editedAgendaId));
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // Optimize re-renders - only update if relevant state changes
        // Note: monthExpended only affects which accordion is open, handled by individual MonthAccordion components
        if (this.state.loading !== nextState.loading) return true;
        if (this.state.redirect !== nextState.redirect) return true;
        if (this.state.requestInProgress !== nextState.requestInProgress) return true;
        if (this.state.description !== nextState.description) return true;
        if (this.state.year !== nextState.year) return true;
        if (this.state.isActive !== nextState.isActive) return true;
        if (this.state.openEditPopup !== nextState.openEditPopup) return true;
        if (this.state.agendaDetails !== nextState.agendaDetails) return true;
        if (this.state.timetables !== nextState.timetables) return true;
        if (this.props.resources !== nextProps.resources) return true;
        if (this.state.id !== nextState.id) return true;
        if (this.state.modifiedOn !== nextState.modifiedOn) return true;
        
        // monthExpended change should trigger render for accordion expansion
        if (this.state.monthExpended !== nextState.monthExpended) return true;
        
        return false;
    }

    handleChange = e => {
        if (e.target.name === "year") {
            this.setState({ [e.target.name]: e.target.value, agendaDetails: GetDefaultAgendasDetails(e.target.value) });
            return;
        }

        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleSubmit = () => {
        if (this.state.id == 0) {
            this.saveNewAgenda();
        }
        else {
            this.saveEditedAgenda();
        }
    }

    getAgendaById = (agendaId) => {
        this.setState({ requestInProgress: true })

        const url = WorkshopAgendasWithIdUrl(agendaId);

        appFetch({
            url: url,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    var agendasDetails = GetDefaultAgendasDetails(data.year);

                    // Optimize: Create a Map for O(1) lookup instead of O(n²)
                    const detailsMap = new Map();
                    data.details.forEach(newItem => {
                        const key = SetFixedDatetimeFormat(new Date(newItem.startOfWeek));
                        detailsMap.set(key, newItem.timetable !== null ? newItem.timetable.id : 0);
                    });

                    // Single pass through agendaDetails
                    agendasDetails.forEach(oldItem => {
                        if (detailsMap.has(oldItem.startOfWeek)) {
                            oldItem.timetableId = detailsMap.get(oldItem.startOfWeek);
                        }
                    });

                    this.setState({
                        id: data.id,
                        description: data.description,
                        isActive: data.isActive,
                        year: data.year,
                        loading: false,
                        modifiedOn: data.modifiedOn,
                        modifiedByName: data.modifiedBy.firstName + " " + data.modifiedBy.lastName,
                        modifiedByAvatar: data.modifiedBy.avatar,
                        agendaDetails: agendasDetails
                    });
                }
            },
            onError: (data) => {

            },
            onFinalize: () => {
                this.setState({ requestInProgress: false })
            }
        })
    }

    isValidForm = () => {
        const { description, year } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        if (!year || year < 2000 || year > 2200) {
            return false;
        }

        return true;
    }

    saveNewAgenda = () => {
        let resources = this.props.resources;
        if (!this.isValidForm()) {
            return;
        };

        this.setState({ requestInProgress: true });

        // Convert startOfWeek from MM/dd/yyyy to yyyy-MM-dd format for API
        const validTimetables = GetValidTimetables(this.state.agendaDetails).map(detail => {
            // Parse MM/dd/yyyy format and convert to yyyy-MM-dd
            const [month, day, year] = detail.startOfWeek.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            
            return {
                ...detail,
                startOfWeek: formattedDate
            };
        });

        var json = JSON.stringify({
            description: this.state.description,
            year: this.state.year,
            isActive: this.state.isActive,
            details: validTimetables,
        });


        const url = WorkshopAgendasUrl();

        appFetch({
            url: url,
            method: 'POST',
            body: json,
            onSuccess: () => {
                DisplayMessage(resources["NewAgendaWasSaved"], "success");
                this.setState({ openEditPopup: false, redirect: "/agendas", agendasWasCreated: true });
            },
            onError: (data) => {
                for (var i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    saveEditedAgenda = () => {
        let resources = this.props.resources;
        if (!this.isValidForm()) {
            return;
        }

        this.setState({ requestInProgress: true });

        // Convert startOfWeek from MM/dd/yyyy to yyyy-MM-dd format for API
        const validTimetables = GetValidTimetables(this.state.agendaDetails).map(detail => {
            // Parse MM/dd/yyyy format and convert to yyyy-MM-dd
            const [month, day, year] = detail.startOfWeek.split('/');
            const formattedDate = `${year}-${month}-${day}`;
            
            return {
                ...detail,
                startOfWeek: formattedDate
            };
        });

        var json = JSON.stringify({
            description: this.state.description,
            year: this.state.year,
            isActive: this.state.isActive,
            details: validTimetables,
        });

        const url = WorkshopAgendasWithIdUrl(this.state.id);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (data, response) => {
                this.setState({ updateInProgress: false, redirect: (response.ok ? '/agendas' : null), timetableWasEdited: response.ok, agendasWasCreated: response.ok });
                this.handleClose();
                DisplayMessage(resources["AgendaWasSaved"], "success");
            },
            onError: (data, response) => {
                var errors = data.errors
                for (var i = 0; i < errors.length; i++) {
                    DisplayMessage(errors[i], "error");
                }
                this.setState({ updateInProgress: false, redirect: (response.ok ? '/agendas' : null), timetableWasEdited: response.ok, agendasWasCreated: response.ok });
                this.handleClose();
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderModifiedByInfo = () => {
        if (this.state.id > 0) {
            return (
                <ModifiedByInfo
                  resources={this.props.resources}
                  modifiedByAvatar={this.state.modifiedByAvatar}
                  modifiedOn={this.state.modifiedOn}
                  modifiedByName={this.state.modifiedByName}
                  className="mt-4"
                />
              );
        }

        return;
    }

    handleClose = () => {
        this.setState({ openEditPopup: false, redirect: "/agendas" });
    }

    getTimetables = () => {
        const url = WorkshopTimetablesUrl();

        this.setState({ requestInProgress: true });

        appFetch({
            url: url,
            onSuccess: (data) => {
                const timetables = [];

                data.forEach(function (item) {
                    if (item.isActive === true) {
                        timetables.push({
                            id: item.id,
                            description: item.description,
                        });
                    }
                });
                var timetablesSorted = timetables.sort((a, b) => (a.description > b.description) ? 1 : -1);
                this.setState({ timetables: timetablesSorted });
            },
            onError: () => {

            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleChangeMonth = (month) => {
        var newPannel = "month" + month

        if (newPannel === this.state.monthExpended) {
            newPannel = "";
        }

        this.setState({ monthExpended: newPannel });
    };

    handleChangeTimetable = e => {
        // Optimize: Create new array to trigger proper re-render and improve performance
        const startOfWeek = e.target.name;
        const newTimetableId = e.target.value;

        this.setState(prevState => ({
            agendaDetails: prevState.agendaDetails.map(item =>
                item.startOfWeek === startOfWeek
                    ? { ...item, timetableId: newTimetableId }
                    : item
            )
        }));
    };

    handleTimatablesCopy = () => {
        this.setState(prevState => {
            const firstTimetableId = prevState.agendaDetails[0].timetableId;
            return {
                agendaDetails: prevState.agendaDetails.map((item, index) =>
                    index === 0 ? item : { ...item, timetableId: firstTimetableId }
                )
            };
        });
    }

    handleTimatablesReset = (val) => {
        this.setState(prevState => ({
            agendaDetails: prevState.agendaDetails.map(item =>
                item.startOfWeek === val
                    ? { ...item, timetableId: 0 }
                    : item
            )
        }));
    }

    renderAgendasDetails = () => {
        const resources = this.props.resources;
        // Cache timetables options to prevent recreation on every render
        const timetables = this.state.timetables.map(x => ({ key: x.id, name: x.description }));

        const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        const monthsName = [
            resources["January"], resources["February"], resources["March"], 
            resources["April"], resources["May"], resources["June"],
            resources["July"], resources["August"], resources["September"], 
            resources["October"], resources["November"], resources["December"]
        ];

        return (
            <div className="col-md-12 m-0 p-0">
                {months.map(month => (
                    <MonthAccordion
                        key={`month${month}`}
                        month={month}
                        monthName={monthsName[month]}
                        year={this.state.year}
                        resources={resources}
                        expanded={this.state.monthExpended === `month${month}`}
                        agendaDetails={this.state.agendaDetails}
                        timetables={timetables}
                        onExpandChange={() => this.handleChangeMonth(month)}
                        onTimetableChange={this.handleChangeTimetable}
                        onTimetableReset={this.handleTimatablesReset}
                        onTimetablesCopy={this.handleTimatablesCopy}
                    />
                ))}
            </div>
        );
    }

    renderForm() {
        const { redirect, requestInProgress, isActive, openEditPopup, editedAgendaId, agendasWasCreated, description, year } = this.state;
        const { resources } = this.props;

        if (redirect) {
            return <Redirect to={{ pathname: this.state.redirect, state: { agendasWasCreated, refreshGrid: agendasWasCreated } }} />
        }

        var helperTextYear = year === "" ? "helper-text-red" : "helper-text-grey";
        var helperTextDescription = description === "" ? "helper-text-red" : "helper-text-grey";
        var isDisabled = editedAgendaId > 0;

        const handleSubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.handleSubmit();
        };

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (

            <Dialog fullScreen open={openEditPopup} onClose={this.handleClose} TransitionComponent={Transition}>
                <Form onSubmit={handleSubmit} >

                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton edge="start" className="float-left " color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {editedAgendaId !== undefined ? resources["EditAgenda"] : resources["AddNewAgendaTitle"]}
                            </Typography>
                            <Button autoFocus color="inherit" id="saveItem" type="submit" disabled={isSaveButtonDisabled} onClick={this.saveTimetable}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>

                    <div className="container">
                        <div className="py-4 grey">
                            <Paper elevation={3} className="p-4 mt-3 mb-3">
                                <FormGroup display="flex" flexDirection="column" style={{ flexWrap: "nowrap" }}>
                                    <ThemeProvider theme={SelectTheme}>
                                        <TextField className={"mb-4 " + helperTextDescription}
                                            id="description"
                                            inputProps={{ maxLength: 100 }}
                                            value={description}
                                            name="description"
                                            label={resources["Description"]}
                                            helperText={resources["DescriptionHelperText"]}
                                            variant="outlined" onChange={this.handleChange} />
                                        <TextField className={"col-md-2 " + helperTextYear} id="year" inputProps={{ maxLength: 4 }} value={year} name="year" type="number"
                                            onKeyDown={ExcludeSpecialCharactersFromInputTypeNumber(false)}
                                            label={resources["Year"]} disabled={isDisabled} helperText={resources["YearHelperText"]} variant="outlined" onChange={this.handleChange} />
                                    </ThemeProvider>
                                    <FormGroup row>
                                        <FormControlLabel control={<Checkbox checked={isActive} onChange={this.handleChangeCheckBox} name="isActive" color="primary" />} label={resources["IsActive"]} />
                                    </FormGroup>
                                    <FormGroup row >
                                        {this.renderAgendasDetails()}
                                    </FormGroup>
                                    {this.renderModifiedByInfo()}
                                </FormGroup>
                            </Paper>
                        </div>
                    </div>
                </Form>
            </Dialog>
        );
    }

    render() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>)
        }

        return (
            <div className={"pt-4 grey text-center" + (this.state.loading ? 'fadeOut' : 'fadeIn')} >
                <div className="container">
                    {this.renderForm()}
                </div>
            </div>
        );
    }
}